module.exports = __webpack_public_path__ + "static/media/workplace.bcfdccd3.jpg";